var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_vm._v(" "+_vm._s(_vm.step.title)+" "),(!_vm.$parent.$parent.isPolling)?_c('span',{on:{"click":function($event){return _vm.goToStep(_vm.step.id)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'edit']}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }